import ResumeLink from 'components/ResumeLink'
import ReviewLink from 'components/ReviewLink'
import StartLink from 'components/StartLink'

export default {
  'not attempted': {
    Button: StartLink,
    text: 'START',
  },
  incomplete: {
    Button: ResumeLink,
    text: 'RESUME',
  },
  completed: {
    Button: ReviewLink,
    text: 'REVIEW',
  },
}
